import {
    Box,
    Button,
    Card,
    TextField,
    Typography
} from "@mui/material"

import { DimensionType } from "../../models";
import { Issue } from "../../models";
import { MeasurementUnit } from "../../models";
import { SubmitQuickQuoteInput } from "../../API";
import { graphQLQuickQuoteClient } from "../../lib/quickQuote/client/GraphQLSubmitQuickQuoteClient";
import { useFormik } from "formik";
import { useState } from "react";

export const QuickQuoteSubmission = ({ issue }: { issue: Issue }) => {
    const [isLoading, setIsLoading] = useState(false);
    const formik = useFormik({
        initialValues: {
            length: "",
            width: "",
        },
        onSubmit: async (values) => {
            setIsLoading(true);
            console.log("length", values.length, "width", values.width, issue.id);
            // send submission to new lambda
            try {
                const input: SubmitQuickQuoteInput[] = [{
                    issueId: issue.id,
                    measurementUnit: MeasurementUnit.FOOT,
                    width: Number(values.width),
                    length: Number(values.length),
                    dimensionType: DimensionType.SQUARE
                }];
                const result = await graphQLQuickQuoteClient.submitQuickQuote(input);
                console.log('result from submit: ', result);
            } catch (err) {
                console.log('failed to submit quick quote');
                throw err;
            } finally {
                setIsLoading(true);
            }
        },
    });
    return (
        <Box m={4}>
            <Card sx={{ padding: 4, display: "flex", flexDirection: "column", gap: 2 }}>
                <Typography variant="h2" align="center">Quick Estimate for: {issue.name}</Typography>
                <Typography
                    variant="body1"
                    align="center">
                    Fill out the approximate size of the issue and we'll get back to you in an hour or less!
                </Typography>
                <form onSubmit={formik.handleSubmit}>
                    <Box
                        display="flex"
                        sx={{ flexDirection: { xs: "column", s: "row", m: "row", lg: "row", xl: "row" } }}
                        justifyContent="center"
                        alignItems="center"
                        gap={2}
                    >
                        <TextField
                            type="number"
                            id="length"
                            name="length"
                            label="length"
                            variant="outlined"
                            sx={{ maxWidth: "150px" }}
                            value={formik.values.length}
                            onChange={formik.handleChange}
                        />
                        <TextField
                            type="number"
                            id="width"
                            name="width"
                            label="width"
                            variant="outlined"
                            sx={{ maxWidth: "150px" }}
                            value={formik.values.width}
                            onChange={formik.handleChange}
                        />
                        <Button sx={{ maxWidth: "150px" }} variant="contained" type="submit">Submit</Button>
                    </Box>
                </form>
            </Card>
        </Box>
    );
}